// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'watch';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.75 4.219h8.5s1.063 0 1.063 1.062v7.438s0 1.062-1.063 1.062h-8.5s-1.063 0-1.063-1.062V5.28s0-1.062 1.063-1.062z' />
    <path d='M12.188 4.219H5.811l.384-2.302a1.062 1.062 0 0 1 1.048-.886h3.512a1.062 1.062 0 0 1 1.048.886zm-6.375 9.562h6.375l-.384 2.302a1.062 1.062 0 0 1-1.048.888H7.244a1.062 1.062 0 0 1-1.048-.888z' />
  </g>
);

export const viewBox = '0 0 18 18';
